export const OptionsIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
  >
    <line x1="4" y1="8" x2="20" y2="8" />
    <line x1="4" y1="16" x2="20" y2="16" />
    <circle cx="9" cy="8" r="2.6" fill="currentColor" stroke="none" />
    <circle cx="15" cy="16" r="2.6" fill="currentColor" stroke="none" />
  </svg>
);
